import React, { Suspense } from "react"
import { useLocation, Navigate, Outlet, Link } from "react-router-dom"
import { Header } from "./Header"
import { LoadingSpinner } from "../ui/LoadingSpinner"
import { useDynamicTitle } from "../../routes/route-utils"
import userService from "../../services/users/userService"
import authService from "../../services/authService"

// Layout component for admin routes
export const AdminLayout = () => {
    const location = useLocation()
    const currentRole = userService.getRoleFromToken()

    // Apply dynamic title (always call hook regardless of conditions)
    useDynamicTitle()

    // If user is not admin/manager, redirect them to their appropriate dashboard
    if (currentRole && !["admin", "manager"].includes(currentRole)) {
        const baseRoute = authService.getBaseRouteForRole()
        return <Navigate to={baseRoute} replace />
    }

    return (
        <div className="min-h-screen flex flex-col overflow-hidden">
            <Header />
            <main className="flex-grow">
                <Suspense fallback={<LoadingSpinner />}>
                    <Outlet />
                </Suspense>
            </main>
        </div>
    )
}

// Comptable layout for comptable routes
export const ComptableLayout = () => {
    const location = useLocation()
    const currentRole = userService.getRoleFromToken()

    // Apply dynamic title
    useDynamicTitle()

    // If user is not comptable, redirect them to their appropriate dashboard
    if (currentRole !== "comptable") {
        const baseRoute = authService.getBaseRouteForRole()
        return <Navigate to={baseRoute} replace />
    }

    return (
        <div className="min-h-screen flex flex-col overflow-hidden">
            <Header />
            <main className="flex-grow">
                <Suspense fallback={<LoadingSpinner />}>
                    <Outlet />
                </Suspense>
            </main>
        </div>
    )
}

// Simple cashier layout for sub-pages (not the dashboard)
export const CashierLayout = () => {
    // Apply dynamic title
    useDynamicTitle()

    // Use the location from React Router
    const location = useLocation()

    return (
        <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col">
            <header className="bg-white dark:bg-neutral-800 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
                    <div className="flex items-center">
                        <Link to="/cashier" className="mr-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-neutral-800 dark:text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </Link>
                        <h1 className="text-xl font-medium text-neutral-800 dark:text-white">
                            {location.pathname.includes("/pos") && "Point of Sale"}
                            {location.pathname.includes("/refunds") && "Refunds"}
                            {location.pathname.includes("/sales") && "Sales"}
                            {location.pathname.includes("/clients") && "Clients"}
                        </h1>
                    </div>
                </div>
            </header>
            <main className="flex-grow">
                <Suspense fallback={<LoadingSpinner />}>
                    <Outlet />
                </Suspense>
            </main>
            <footer className="py-4 text-center text-neutral-500 dark:text-neutral-400 text-sm">
                <p>© {new Date().getFullYear()} POSNex System. All rights reserved.</p>
            </footer>
        </div>
    )
}